<div class="container d-flex justify-content-center align-items-center mt-7">
    <div class="text-center">
        <div class="mb-4">
            <!-- Success Icon -->
            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="green" class="bi bi-check-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
                <path d="M11.97 5.97a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0z" />
            </svg>
        </div>
        <h2 class="mb-4">Paiement réussi!</h2>
        <p class="mb-4">Votre paiement a été traité avec succès. Merci de votre confiance!</p>
        <div>
            <button (click)="navigateTo('mes-reservations')" class="btn btn-outline-studiomap"><i class="ni ni-bullet-list-67 mr-2"></i>Mes réservations</button>
        </div>
    </div>
</div>
